import { render, staticRenderFns } from "./ActivityItemTask.vue?vue&type=template&id=57283817&scoped=true&"
import script from "./ActivityItemTask.vue?vue&type=script&lang=js&"
export * from "./ActivityItemTask.vue?vue&type=script&lang=js&"
import style0 from "./ActivityItemTask.vue?vue&type=style&index=0&id=57283817&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57283817",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57283817')) {
      api.createRecord('57283817', component.options)
    } else {
      api.reload('57283817', component.options)
    }
    module.hot.accept("./ActivityItemTask.vue?vue&type=template&id=57283817&scoped=true&", function () {
      api.rerender('57283817', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ActivityItemTask.vue"
export default component.exports